module.exports = __webpack_public_path__ + "img/global-savings-header.f824dfd5.png";